import { app, globalMatrix, IItemGet, matrixSession } from "../../../globals";
import { IDropdownOption } from "../../../ProjectSettings";
import { FieldHandlerFactory, MR1 } from "../../businesslogic/index";
import { mDHF } from "../../businesslogic/index";
import { ml } from "../../matrixlib";
import { IBaseControlOptions } from "./BaseControl";
import { ISignaturesInfo } from "./docBase.";
import { DocSignImpl } from "./docSign";
import { FieldDescriptions } from "../../businesslogic/FieldDescriptions";
import { EmptyFieldHandler } from "../../businesslogic/FieldHandlers/EmptyFieldHandler";
import { GenericFieldHandler } from "../../businesslogic/FieldHandlers/GenericFieldHandler";
import { ControlState } from "../../../types";

export type {
    IDocMarkAsTemplateOptions,
    IPasteSourceSetting,
    IPasteSource,
    ITempSignatures,
    ITempSignature,
    ITemplateProjects,
};
export { MarkAsTemplateImpl };

interface IDocMarkAsTemplateOptions extends IBaseControlOptions {
    controlState?: ControlState;
    canEdit?: boolean;
    help?: string;
    fieldValue?: string;
    // TODO: MATRIX-7555: lint errors should be fixed for next line
    // eslint-disable-next-line
    valueChanged?: Function;
    parameter?: {
        inlineHelp?: string;
    };
}
interface IPasteSourceSetting {
    templates: IPasteSource[];
}
interface IPasteSource {
    fromProject: string; // project where template comes from
    fromSign: string; // template (a SIGN or a DOC)
    fromName: string; // the name at time of publishing
    fromDOC: string; // if SIGN, the DOC which was made a source
    canUseIn: string[]; // list of projects where template can be instantiated
}

interface ITempSignatures {
    signatures: ITempSignature[];
}
interface ITempSignature {
    user: string; // user to sign
    datetime: string; // date when it was signed
}

// TODO: MATRIX-7555: lint errors should be fixed for next line
// eslint-disable-next-line
$.fn.markAsTemplate = function (this: JQuery, options: IDocMarkAsTemplateOptions) {
    if (!options.fieldHandler) {
        options.fieldHandler = FieldHandlerFactory.CreateHandler(
            globalMatrix.ItemConfig,
            FieldDescriptions.Field_markAsTemplate,
            options,
        );
        options.fieldHandler.initData(JSON.stringify(options.fieldValue));
    }
    let baseControl = new MarkAsTemplateImpl(this, options.fieldHandler as GenericFieldHandler);
    // TODO: MATRIX-7555: lint errors should be fixed for next line
    // eslint-disable-next-line
    this.getController = () => {
        return baseControl;
    };
    baseControl.init(options);
    return this;
};

interface ITemplateProjects {
    projects: string[];
    targets: string[];
}

class MarkAsTemplateImpl extends DocSignImpl {
    public static PROJECT_SETTING: string = "templates";
    public static PROJECT_SETTING_Projects: string = "templateProjects";

    // @ts-ignore TODO: MATRIX-6934: nullStrictCheck should be fixed for next line
    private originalValue: ITempSignatures;
    // @ts-ignore TODO: MATRIX-6934: nullStrictCheck should be fixed for next line
    private newValue: ITempSignatures;
    // @ts-ignore TODO: MATRIX-6934: nullStrictCheck should be fixed for next line
    private pub: JQuery;
    private publishTo: string[] = [];
    constructor(control: JQuery, fieldHandler: GenericFieldHandler) {
        super(control, fieldHandler);
    }

    // TODO: MATRIX-7555: lint errors should be fixed for next line
    // eslint-disable-next-line
    private formatUserLogin(userLogin: string) {
        return globalMatrix.ItemConfig.hasUserInfo(userLogin) ? userLogin : `<s>${userLogin}</s>`;
    }

    // TODO: MATRIX-7555: lint errors should be fixed for next line
    // eslint-disable-next-line
    init(options: IDocMarkAsTemplateOptions) {
        let that = this;

        let defaultOptions = {
            controlState: ControlState.FormView, // read only rendering
            canEdit: false, // whether data can be edited
            // TODO: MATRIX-7555: lint errors should be fixed for next line
            // eslint-disable-next-line
            // TODO: MATRIX-7555: lint errors should be fixed for next line
            // eslint-disable-next-line
            valueChanged: function () {}, // callback to call if value changes
            parameter: {
                // item the item containing the rest of the information
            },
        };
        this.settings = ml.JSON.mergeOptions(defaultOptions, options);

        // changes shall not overwrite other people's changes
        this.needsLatest = true;

        // get current value
        this.originalValue = <ITempSignatures>(this.settings.fieldValue
            ? JSON.parse(this.settings.fieldValue)
            : {
                  signatures: [],
              });
        this.newValue = ml.JSON.clone(this.originalValue);

        // TODO: MATRIX-7555: lint errors should be fixed for next line
        // eslint-disable-next-line
        if (options.controlState == ControlState.Tooltip) {
            return;
        }

        if (!matrixSession.isQMS()) {
            let help = this._root.append(super.createHelp(this.settings));
            this.pub = $("<div class='baseControl'>").appendTo(this._root);
            this.pub.html("This feature requires QMS license.");
            return;
        }

        let docTypes = mDHF.getDocumentFormTypes(); // ["DOC"]
        let templateTypes = mDHF.getDocumentTemplatesTypes(); // ["SIGN"] could be ["SIGN","DOC"]

        // @ts-ignore TODO: MATRIX-6934: nullStrictCheck should be fixed for next line
        // TODO: MATRIX-7555: lint errors should be fixed for next line
        // eslint-disable-next-line
        if (docTypes.indexOf(options.type) != -1) {
            // in print version do not show anything
            // TODO: MATRIX-7555: lint errors should be fixed for next line
            // eslint-disable-next-line
            if (options.controlState == ControlState.Print) {
                return;
            }
            // this is a DOC, user needs to decide who needs to sign the template to release it
            this.showSignatureTableEdit();
            return;
        }

        // @ts-ignore TODO: MATRIX-6934: nullStrictCheck should be fixed for next line
        // TODO: MATRIX-7555: lint errors should be fixed for next line
        // eslint-disable-next-line
        if (templateTypes.indexOf(options.type) == -1) {
            // neither a DOC not a SIGN...
            this._root.html("config error: This category cannot be used as template - contact support.");
            return;
        }

        // so this is a SIGN and it's a DOC which still exists
        let signs = this.getTemplateSignatureStatus();
        // TODO: MATRIX-7555: lint errors should be fixed for next line
        // eslint-disable-next-line
        if (signs.signatures.length == 0) {
            // in print version do not show anything
            // TODO: MATRIX-7555: lint errors should be fixed for next line
            // eslint-disable-next-line
            if (options.controlState == ControlState.Print) {
                this.hideSignatureCtrl();
            }
            // this is a normal document as SIGN .. ignore all template  stuff
            return;
        }

        // this is a SIGN or something which has been created from a DOC
        // @ts-ignore TODO: MATRIX-6934: nullStrictCheck should be fixed for next line
        let uplinks = options.item.upLinkList
            ? // @ts-ignore TODO: MATRIX-6934: nullStrictCheck should be fixed for next line
              options.item.upLinkList.filter(function (uplink) {
                  // TODO: MATRIX-7555: lint errors should be fixed for next line
                  // eslint-disable-next-line
                  return docTypes.indexOf(ml.Item.parseRef(uplink.itemRef).type) != -1;
              })
            : [];
        if (uplinks && uplinks.length) {
            // this is actually a template, so the template needs approvals

            // hide signature box
            this.hideSignatureCtrl();

            // print approval box / template publishing feature
            if (signs.missingSignatures) {
                // @ts-ignore TODO: MATRIX-6934: nullStrictCheck should be fixed for next line
                // @ts-ignore TODO: MATRIX-6934: nullStrictCheck should be fixed for next line
                // TODO: MATRIX-7555: lint errors should be fixed for next line
                // eslint-disable-next-line
                // TODO: MATRIX-7555: lint errors should be fixed for next line
                // eslint-disable-next-line
                if (this.settings.help.indexOf("|") != -1 && this.settings.help.lastIndexOf("|") != -1) {
                    // @ts-ignore TODO: MATRIX-6934: nullStrictCheck should be fixed for next line
                    this.settings.help = this.getHelpPart(1)
                        ? this.getHelpPart(1)
                        : this.settings.help + " - (required approvals)";
                }
                if (
                    this.settings.parameter &&
                    this.settings.parameter.inlineHelp &&
                    // TODO: MATRIX-7555: lint errors should be fixed for next line
                    // eslint-disable-next-line
                    this.settings.parameter.inlineHelp.indexOf("|") != -1
                ) {
                    this.settings.parameter.inlineHelp = this.settings.parameter.inlineHelp.split("|")[0];
                }
                let help = this._root.append(super.createHelp(this.settings));
                this.pub = $("<div class='baseControl'>").appendTo(this._root);
                this.askForSignatures(signs);
            } else {
                // @ts-ignore TODO: MATRIX-6934: nullStrictCheck should be fixed for next line
                this.settings.help = this.getHelpPart(2)
                    ? this.getHelpPart(2)
                    : this.settings.help + " - (distribution to projects)";
                let help = this._root.append(super.createHelp(this.settings));
                if (
                    this.settings.parameter &&
                    this.settings.parameter.inlineHelp &&
                    // TODO: MATRIX-7555: lint errors should be fixed for next line
                    // eslint-disable-next-line
                    this.settings.parameter.inlineHelp.indexOf("|") != -1
                ) {
                    this.settings.parameter.inlineHelp = this.settings.parameter.inlineHelp.split("|")[0];
                }
                this.pub = $("<div class='baseControl'>").appendTo(this._root);
                let vl = ml.Item.parseRef(uplinks[0].itemRef).id;
                if (signs.signatures.length > 0) {
                    let approvedBy = $("<div class='inlineHelp approvedBy'>").appendTo(this.pub);
                    let text = "Approved by ";
                    $.each(signs.signatures, function (sidx, s) {
                        text +=
                            that.formatUserLogin(s.userid) +
                            " (" +
                            ml.UI.DateTime.renderHumanDate(new Date(s.signDate)) +
                            " )" +
                            (sidx < signs.signatures.length - 1 ? ", " : "");
                    });

                    approvedBy.html(text);
                }
                // TODO: MATRIX-7555: lint errors should be fixed for next line
                // eslint-disable-next-line
                if (options.controlState == ControlState.Print) {
                    return;
                }
                // @ts-ignore TODO: MATRIX-6934: nullStrictCheck should be fixed for next line
                this.showProjects(vl, options.id);
            }
        } else {
            let help = this._root.append(super.createHelp(this.settings));
            this.pub = $("<div class='baseControl'>").appendTo(this._root);
            this.pub.html("Cannot be used as template: underlying " + docTypes.join(",") + " has been deleted.");
        }
    }

    // TODO: MATRIX-7555: lint errors should be fixed for next line
    // eslint-disable-next-line
    private getHelpPart(part: number) {
        // @ts-ignore TODO: MATRIX-6934: nullStrictCheck should be fixed for next line
        let parts = this.settings.help.split("|");
        // TODO: MATRIX-7555: lint errors should be fixed for next line
        // eslint-disable-next-line
        return parts.length == 3 ? parts[part] : null;
    }
    // public interface
    // TODO: MATRIX-7555: lint errors should be fixed for next line
    // eslint-disable-next-line
    async hasChangedAsync() {
        // TODO: MATRIX-7555: lint errors should be fixed for next line
        // eslint-disable-next-line
        return JSON.stringify(this.originalValue) != JSON.stringify(this.newValue);
    }
    // TODO: MATRIX-7555: lint errors should be fixed for next line
    // eslint-disable-next-line
    async getValueAsync() {
        return JSON.stringify(this.newValue);
    }
    // TODO: MATRIX-7555: lint errors should be fixed for next line
    // eslint-disable-next-line
    setValue() {
        return "";
    }

    // TODO: MATRIX-7555: lint errors should be fixed for next line
    // eslint-disable-next-line
    // TODO: MATRIX-7555: lint errors should be fixed for next line
    // eslint-disable-next-line
    destroy() {}
    // TODO: MATRIX-7555: lint errors should be fixed for next line
    // eslint-disable-next-line
    resizeItem() {
        let width = $("input.signatureInfo", this._root).width();
        $("table td:first-child", this._root).width(width);
    }

    // TODO: MATRIX-7555: lint errors should be fixed for next line
    // eslint-disable-next-line
    static getRequiredApprovals(value: string) {
        let required: string[] = [];

        if (!value) {
            return required;
        }
        let jval = <ITempSignatures>JSON.parse(value);
        if (!jval.signatures) {
            return required;
        }

        for (let idx = 0; idx < jval.signatures.length; idx++) {
            if (!jval.signatures[idx].datetime) {
                required.push(jval.signatures[idx].user);
            }
        }

        return required;
    }

    static getTemplateSignatureStatus(value: string): ISignaturesInfo {
        let signatureStatus: ISignaturesInfo = {
            signatures: [],
            missing: [],
            given: [],
            signatureDate: {},
            missingSignatures: 0,
            givenSignatures: 0,
            needSignature: false,
            hasSignature: false,
            isTemplate: true,
        };
        if (!value) {
            return signatureStatus;
        }
        let jval = <ITempSignatures>JSON.parse(value);
        if (!jval.signatures) {
            return signatureStatus;
        }
        // matrixspecs

        $.each(jval.signatures, function (key, val) {
            if (val.user) {
                // workaround handle existing docs with BUG MATRIX-2442 correctly
                signatureStatus.signatures.push({
                    orgid: val.user,
                    userid: val.user,
                    signDateCustomer: ml.UI.DateTime.renderHumanDate(new Date(val.datetime)),
                    signDate: val.datetime,
                    signaturefileid: "",
                });
                if (val.datetime) {
                    signatureStatus.given.push(val.user);
                    signatureStatus.givenSignatures++;
                    // TODO: MATRIX-7555: lint errors should be fixed for next line
                    // eslint-disable-next-line
                    signatureStatus.hasSignature = signatureStatus.hasSignature || val.user == matrixSession.getUser();
                } else {
                    signatureStatus.missing.push(val.user);
                    signatureStatus.missingSignatures++;
                    signatureStatus.needSignature =
                        // TODO: MATRIX-7555: lint errors should be fixed for next line
                        // eslint-disable-next-line
                        signatureStatus.needSignature || val.user == matrixSession.getUser();
                }
                signatureStatus.signatureDate[val.user] = ml.UI.DateTime.renderHumanDate(new Date(val.datetime));
            }
        });
        return signatureStatus;
    }

    // TODO: MATRIX-7555: lint errors should be fixed for next line
    // eslint-disable-next-line
    static removeFromTemplates(deletedItems: string[]) {
        let cached = <IPasteSourceSetting>globalMatrix.ItemConfig.getSettingJSON(MarkAsTemplateImpl.PROJECT_SETTING);

        // check if any item is used as template if not // nothing to do
        if (
            !cached ||
            !cached.templates ||
            cached.templates.filter(function (temp) {
                // TODO: MATRIX-7555: lint errors should be fixed for next line
                // eslint-disable-next-line
                return deletedItems.indexOf(temp.fromSign) != -1;
                // TODO: MATRIX-7555: lint errors should be fixed for next line
                // eslint-disable-next-line
            }).length == 0
        ) {
            return;
        }
        // get most recent setting
        app.readSettingJSONAsync(MarkAsTemplateImpl.PROJECT_SETTING).done(function (templates: IPasteSourceSetting) {
            templates.templates = templates.templates.filter(function (temp) {
                // TODO: MATRIX-7555: lint errors should be fixed for next line
                // eslint-disable-next-line
                return deletedItems.indexOf(temp.fromSign) == -1;
            });
            app.setSettingJSON(MarkAsTemplateImpl.PROJECT_SETTING, templates);
        });
    }

    // TODO: MATRIX-7555: lint errors should be fixed for next line
    // eslint-disable-next-line
    private hideSignatureCtrl() {
        $(".ft_signatureControl").hide();
        window.setTimeout(function () {
            // just to be sure...
            $(".ft_signatureControl").hide();
        }, 100);
    }
    // TODO: MATRIX-7555: lint errors should be fixed for next line
    // eslint-disable-next-line
    private showProjects(sourceDoc: string, sourceSign: string) {
        let that = this;

        // get current project setting
        app.readSettingJSONAsync(MarkAsTemplateImpl.PROJECT_SETTING).done(function (result) {
            let templates = <IPasteSourceSetting>result;
            if (!templates || !templates.templates) {
                templates = { templates: [] };
            }

            // print table
            that.publishTo = [];
            that.showCurrentUsages(templates.templates, sourceDoc, sourceSign);
            let pb = $(
                "<button id='pubTemp' class='btn btn-success btn-sm'>Publish as template for selected projects</button>",
            ).appendTo(that.pub);
            pb.click(function () {
                // make sure to have latest and greatest
                app.readSettingJSONAsync(MarkAsTemplateImpl.PROJECT_SETTING).done(function (result) {
                    templates = <IPasteSourceSetting>result;
                    if (!templates || !templates.templates) {
                        templates = { templates: [] };
                    }
                    // update
                    $.each(templates.templates, function (idx, ps) {
                        // TODO: MATRIX-7555: lint errors should be fixed for next line
                        // eslint-disable-next-line
                        // TODO: MATRIX-7555: lint errors should be fixed for next line
                        // eslint-disable-next-line
                        if (ps.fromProject == matrixSession.getProject() && ps.fromSign != sourceSign) {
                            // TODO: MATRIX-7555: lint errors should be fixed for next line
                            // eslint-disable-next-line
                            if (ps.fromDOC == sourceDoc) {
                                // for other items based on the same docs, remove everything which is being published somewhere else
                                ps.canUseIn = ps.canUseIn.filter(function (p) {
                                    // TODO: MATRIX-7555: lint errors should be fixed for next line
                                    // eslint-disable-next-line
                                    let doPublish = that.publishTo.indexOf(p) != -1;
                                    return !doPublish;
                                });
                            }
                        }
                    });
                    // remove templates which are not visible in any projects
                    templates.templates = templates.templates.filter(function (temp) {
                        return temp.canUseIn.length > 0;
                    });
                    // remove publishing info for this sign
                    templates.templates = templates.templates.filter(function (temp) {
                        // TODO: MATRIX-7555: lint errors should be fixed for next line
                        // eslint-disable-next-line
                        // TODO: MATRIX-7555: lint errors should be fixed for next line
                        // eslint-disable-next-line
                        return temp.fromProject != matrixSession.getProject() || temp.fromSign != sourceSign;
                    });

                    const project = matrixSession.getProject();

                    if (project) {
                        // add publishing info for this sign
                        templates.templates.push({
                            fromProject: project,
                            fromDOC: sourceDoc,
                            fromSign: sourceSign,
                            fromName: app.getItemTitle(sourceSign),
                            canUseIn: ml.JSON.clone(that.publishTo),
                        });

                        app.setSettingJSON(MarkAsTemplateImpl.PROJECT_SETTING, templates).done(function () {
                            that.pub.html("");
                            that.showProjects(sourceDoc, sourceSign);
                        });
                    }
                });
            });
        });
    }

    // TODO: MATRIX-7555: lint errors should be fixed for next line
    // eslint-disable-next-line
    private showCurrentUsages(current: IPasteSource[], sourceDoc: string, sourceSign: string) {
        let that = this;

        // figure out what is currently used as template
        let others: string[] = [];
        $.each(current, function (idx, ps) {
            // TODO: MATRIX-7555: lint errors should be fixed for next line
            // eslint-disable-next-line
            if (ps.fromProject == matrixSession.getProject()) {
                // TODO: MATRIX-7555: lint errors should be fixed for next line
                // eslint-disable-next-line
                if (ps.fromSign == sourceSign) {
                    // this is currently published
                    that.publishTo = ps.canUseIn;
                    // TODO: MATRIX-7555: lint errors should be fixed for next line
                    // eslint-disable-next-line
                } else if (ps.fromDOC == sourceDoc) {
                    // another version of DOC is used as template in some projects
                    others = others.concat(ps.canUseIn);
                }
            }
        });

        let projects = matrixSession.getProjectList(false).filter(function (p) {
            // TODO: MATRIX-7555: lint errors should be fixed for next line
            // eslint-disable-next-line
            // TODO: MATRIX-7555: lint errors should be fixed for next line
            // eslint-disable-next-line
            return p.shortLabel != "EMPTY" && p.shortLabel != matrixSession.getProject();
        });

        let templateProjects = <ITemplateProjects>(
            matrixSession.getCustomerSettingJSON(MarkAsTemplateImpl.PROJECT_SETTING_Projects)
        );
        if (templateProjects && templateProjects.targets && templateProjects.targets.length) {
            projects = projects.filter(function (p) {
                // TODO: MATRIX-7555: lint errors should be fixed for next line
                // eslint-disable-next-line
                return templateProjects.targets.indexOf(p.shortLabel) != -1;
            });
        }

        let hasUsedOther = false; // whether some have other published versions
        $.each(projects, function (idx, project) {
            let short = project.shortLabel;
            // TODO: MATRIX-7555: lint errors should be fixed for next line
            // eslint-disable-next-line
            hasUsedOther = hasUsedOther || others.indexOf(project.shortLabel) != -1;

            // TODO: convert to const and make sure it's still works
            // eslint-disable-next-line no-var
            var cb = $("<div>")
                .appendTo(that.pub)
                .checkBox({
                    canEdit: true,
                    help:
                        // TODO: MATRIX-7555: lint errors should be fixed for next line
                        // eslint-disable-next-line
                        (others.indexOf(project.shortLabel) != -1 ? "* " : "") +
                        project.shortLabel +
                        " - " +
                        project.label,
                    valueChanged: async function () {
                        if (await cb.getController().getValueAsync()) {
                            that.publishTo.push(short);
                        } else {
                            that.publishTo = that.publishTo.filter(function (p) {
                                // TODO: MATRIX-7555: lint errors should be fixed for next line
                                // eslint-disable-next-line
                                return p != short;
                            });
                        }
                        $("#pubTemp").addClass("btn-success");
                    },
                    parameter: {},
                    // TODO: MATRIX-7555: lint errors should be fixed for next line
                    // eslint-disable-next-line
                    fieldValue: that.publishTo.indexOf(project.shortLabel) == -1 ? "0" : "1",
                });
        });

        if (hasUsedOther) {
            $("<div>").appendTo(that.pub).html("* Some project(s) use another version of template");
        }
    }

    // show a table in DOC, where author can decide who needs to sign to release the document
    // TODO: MATRIX-7555: lint errors should be fixed for next line
    // eslint-disable-next-line
    private showSignatureTableEdit() {
        let that = this;

        let userDropdown: IDropdownOption[] = [];
        let userList = globalMatrix.ItemConfig.getUserNames();
        for (let udx = 0; udx < userList.length; udx++) {
            userDropdown.push({ id: userList[udx].login.toLowerCase(), label: userList[udx].login.toLowerCase() });
        }
        let dd = $("<div>").appendTo(this._root);

        let cb = that.settings.valueChanged;

        // TODO: MATRIX-7555: lint errors should be fixed for next line
        // eslint-disable-next-line
        let userSelectionChanged = async function () {
            let val = await dd.getController().getValueAsync();
            if (val) {
                that.newValue = {
                    // MATRIX-4764 Don't save deleted user.
                    signatures: MarkAsTemplateImpl.removeDeletedUsers(val.split(",")).map(function (usr: string) {
                        return { user: usr, datetime: "" };
                    }),
                };
            } else {
                // fix MATRIX-2442
                that.newValue = {
                    signatures: [],
                };
            }
            if (cb) {
                cb.apply(null);
            }
        };
        let params = {
            fieldValue: that.originalValue.signatures
                .map(function (us) {
                    return us.user;
                })
                .join(","),
            canEdit: true,
            help: that.getHelpPart(0) ? that.getHelpPart(0) : that.settings.help + " - (required approvals)",
            parameter: {
                placeholder: "select user who need to sign template",
                create: false,
                options: userDropdown,
                maxItems: 100,
                sort: true,
                inlineHelp:
                    that.settings.parameter && that.settings.parameter.inlineHelp
                        ? that.settings.parameter.inlineHelp
                        : "",
            },
            valueChanged: userSelectionChanged,
        };

        dd.mxDropdown(params);

        //Fix for MATRIX-4764 Problem with Template approver and deleted users
        let missingUser = that.originalValue.signatures.filter(
            (sig) =>
                // TODO: MATRIX-7555: lint errors should be fixed for next line
                // eslint-disable-next-line
                // TODO: MATRIX-7555: lint errors should be fixed for next line
                // eslint-disable-next-line
                globalMatrix.ItemConfig.getUserNames().findIndex((user) => user.login.toLowerCase() == sig.user) == -1,
        );
        if (missingUser.length > 0) {
            // TODO: MATRIX-7555: lint errors should be fixed for next line
            // eslint-disable-next-line
            let cleanupUserList = () => {
                ml.UI.showAck(
                    -1,
                    "These users has been removed sinced they are no longer active : <ul style='margin-left:80px'>" +
                        missingUser.map((o) => "<li style='text-align:left;'>" + o.user + "</li>").join("") +
                        "</ul> Please save to correct.",
                    "User list has been cleaned in '" + params.help + "'",
                );
                userSelectionChanged();
                MR1.onItemDisplayed().unsubscribe(cleanupUserList);
            };
            MR1.onItemDisplayed().subscribe(this, cleanupUserList);
        }
    }
    static removeDeletedUsers(userList: string[]): string[] {
        return userList.filter(
            (u) =>
                globalMatrix.ItemConfig.getUserNames().findIndex(
                    // TODO: MATRIX-7555: lint errors should be fixed for next line
                    // eslint-disable-next-line
                    (un) => un.login.toLowerCase() == (<string>u).toLowerCase(),
                    // TODO: MATRIX-7555: lint errors should be fixed for next line
                    // eslint-disable-next-line
                ) != -1,
        );
    }

    private getTemplateSignatureStatus(): ISignaturesInfo {
        return MarkAsTemplateImpl.getTemplateSignatureStatus(JSON.stringify(this.originalValue));
    }

    // ask for signatures
    // TODO: MATRIX-7555: lint errors should be fixed for next line
    // eslint-disable-next-line
    private askForSignatures(signatureStatus: ISignaturesInfo) {
        let that = this;

        let uiCtrl = $("<div>").appendTo(this.pub);
        // render a signature table with current status if there is 1+ signature in document
        this.renderSignatureTable(
            signatureStatus,
            uiCtrl,
            "not yet approved",
            "you need to approve this template",
            "approved at",
        );
        // TODO: MATRIX-7555: lint errors should be fixed for next line
        // eslint-disable-next-line
        // TODO: MATRIX-7555: lint errors should be fixed for next line
        // eslint-disable-next-line
        if (this.settings.controlState == ControlState.Print || this.settings.controlState == ControlState.Tooltip) {
            return;
        }
        // show signature box unless user needs to sign or this is a tooltip, print or other special view
        this.showSignatureField(
            signatureStatus,
            uiCtrl,
            $(uiCtrl.find("td")[0]).width(),
            "Approve",
            function (pwd: string) {
                that.signTemplate(pwd);
            },
            true,
        );
    }

    // TODO: MATRIX-7555: lint errors should be fixed for next line
    // eslint-disable-next-line
    protected signTemplate(pwd: string) {
        let that = this;

        app.checkPassword(pwd)
            .done(function () {
                // pwd is correct

                // get item with most current approvals
                // @ts-ignore TODO: MATRIX-6934: nullStrictCheck should be fixed for next line
                app.getItemAsync(that.settings.id)
                    // @ts-ignore TODO: MATRIX-6934: nullStrictCheck should be fixed for next line
                    .done(function (item: IItemGet) {
                        // @ts-ignore TODO: MATRIX-6934: nullStrictCheck should be fixed for next line
                        // TODO: MATRIX-7555: lint errors should be fixed for next line
                        // eslint-disable-next-line
                        let current = (<any>item)[that.settings.fieldId];

                        that.originalValue = <ITempSignatures>(current
                            ? JSON.parse(current)
                            : {
                                  signatures: [],
                              });
                        that.newValue = <ITempSignatures>ml.JSON.clone(that.originalValue);
                        $.each(that.newValue.signatures, function (idx, sig) {
                            // TODO: MATRIX-7555: lint errors should be fixed for next line
                            // eslint-disable-next-line
                            if (sig.user == matrixSession.getUser()) {
                                sig.datetime = new Date().toJSON();
                            }
                        });

                        app.saveAsync(false);
                    })
                    .fail(function (error) {
                        ml.UI.showError("cannot approve template", error);
                    });
            })
            .fail(function (error) {
                ml.UI.showError("invalid password", "");
            });
    }
}
